"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoginForm = void 0;
const react_1 = require("react");
/** Shared login form state and submit handler. Use with LoginCard + LoginFormFields. */
function useLoginForm(login, onSuccess, options) {
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)('');
    const invalidMessage = options?.invalidMessage ?? 'Invalid email or password';
    const handleSubmit = (0, react_1.useCallback)(async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        const ok = await login(email, password);
        if (ok)
            onSuccess();
        else
            setError(invalidMessage);
        setLoading(false);
    }, [email, password, login, onSuccess, invalidMessage]);
    return {
        email,
        setEmail,
        password,
        setPassword,
        loading,
        error,
        handleSubmit,
        onSubmit: handleSubmit,
    };
}
exports.useLoginForm = useLoginForm;
